import React from "react";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "@/utils";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import classnames from "classnames";
import "./style.less";
const { WizButton, WizRow, WizCol, WizNotice, WizIcon } = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;

class AddSection extends WizContainer {
  componentName = "AddSection";

  constructor(props) {
    super(props);

    this.state = {
      record: {}, //当前选中的这条记录
      currentIndex: -1, //当前选中项的索引
      title: "新建章节",
      data: []
    };
  }

  static defaultProps = {};

  _componentDidMount() {
    const arr = [];
    for (let i = 0; i < 100; i++) {
      arr.push({
        key: "a" + i,
        badge:
          Math.random() * 10 < 3
            ? "固定"
            : Math.random() * 10 > 3 && Math.random() * 10 < 6
            ? "随机"
            : "综合",
        title:
          Math.random() * 10 < 3
            ? "单选题"
            : Math.random() * 10 > 3 && Math.random() * 10 < 6
            ? "多选题"
            : "判断题"
      });
    }
    this.setState({
      data: arr
    });
  }

  propsAndStateOnChange = {};

  check = record => {
    if (!record.key) {
      WizNotice.warn("请选择一项");
      return false;
    }
    return true;
  };

  handleClick = (val, index) => {
    this.setState({
      record: val,
      currentIndex: index
    });
  };

  handleDelete = _ => {
    const { record, data } = this.state;
    if (!this.check(record)) return false;
    const filterData = data.filter(val => val.key !== record.key);
    this.setState({
      data: filterData,
      record: {},
      currentIndex: -1
    });
  };

  handleMove = flag => {
    const { record, currentIndex, data } = this.state;
    if (!this.check(record)) return false;
    if (flag === -1) {
      //上移
      if (currentIndex !== 0) {
        //如果不是第一项
        const temp = data[currentIndex];
        data[currentIndex] = data[currentIndex - 1];
        data[currentIndex - 1] = temp;
        this.setState({
          data,
          record: temp,
          currentIndex: currentIndex - 1
        });
      } else {
        //否则
        const filterData = data.concat([data.shift()]);
        this.setState({
          data: filterData,
          record: filterData[filterData.length - 1],
          currentIndex: filterData.length - 1
        });
      }
    } else if (flag === 1) {
      //下移
      if (!this.check(record)) return false;
      if (currentIndex !== data.length - 1) {
        //如果不是最后一项
        const temp = data[currentIndex];
        data[currentIndex] = data[currentIndex + 1];
        data[currentIndex + 1] = temp;
        this.setState({
          data,
          record: temp,
          currentIndex: currentIndex + 1
        });
      } else {
        //否则
        const filterData = [data.pop(), ...data];
        this.setState({
          data: filterData,
          record: filterData[0],
          currentIndex: 0
        });
      }
    } else {
      WizNotice.warn("参数不合法");
    }
  };

  _render() {
    // const { title, data } = this.props;
    const { record, title, data } = this.state;
    return (
      <WizRow>
        <WizCol span={7}>
          <div className="section-add">
            <div className="section-add-title">{title}</div>
            <div className="section-add-body">
              <div className="operate">
                <WizButton type="link" onClick={() => this.handleMove(-1)}>
                  <WizIcon
                    style={{ color: "rgb(67, 207, 124)" }}
                    type="up-circle"
                  />
                </WizButton>
                <WizButton type="link" onClick={() => this.handleMove(1)}>
                  <WizIcon
                    style={{ color: "rgb(67, 207, 124)" }}
                    type="down-circle"
                  />
                </WizButton>
                <WizButton type="link" onClick={() => this.handleDelete()}>
                  <WizIcon
                    style={{ color: "rgb(245, 34, 45)" }}
                    type="delete"
                  />
                </WizButton>
              </div>

              <ul className="section-add-items">
                {data.length
                  ? data.map((val, index) => (
                      <li
                        key={val.key}
                        className={classnames(
                          "section-add-item",
                          val.key === record.key ? "active" : ""
                        )}
                        onClick={() => this.handleClick(val, index)}
                      >
                        <span className="badge">{val.badge}</span>
                        {val.title}
                      </li>
                    ))
                  : null}
              </ul>
            </div>
          </div>
        </WizCol>
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {};

export default connect(mapStateToProps)(AddSection);
